<template>
    <div>
        <div class="flex py-4">
            <div class="w-60 m-auto">
                <MonthPickerDropdown
                    v-model:inputValue="monthSelect"
                    :inputLbl="lbl.history.monthPicker"
                    @update:inputValue="onMonthSelect()"
                ></MonthPickerDropdown>
            </div>
        </div>
        <div class="px-4">
            <OrderHistoryItem
                v-for="(myOrder,index) in myOrders"
                :key="myOrder.tranId"
                :myOrder="myOrder"
                @clickReOrder="clickReOrder($event)"
                @clickDetail="clickDetail($event)"
                @clickFav="clickFav(index)"
            >
            </OrderHistoryItem>
        </div>
    </div>
</template>

<script>
//component
import MonthPickerDropdown from '@/components/Input/label/MonthPickerDropdown.vue';
import OrderHistoryItem from './OrderHistoryItem.vue';
//model
import MyorderConfigModel from '../../model/MyorderConfigModel.js';
//service 
import BKMyOrder from '../../service/BKMyOrder.js'
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
export default {
    name: "OrderHistory",
    mixins: [LocaleMixin,ModalMixin],
    components: {
        MonthPickerDropdown,
        OrderHistoryItem
    },
    data: function() {
        return {
            monthSelect: new Date(),

            orderHistoryConfig: null,

            myOrders: [],
            myOrderDetail: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        }
    },
    created: function() {
        
    },
    methods: {
        onMonthSelect: function () {
            console.log(this.monthSelect);
            this.init();
        },
        init: function() {
            this.orderHistoryConfig = new MyorderConfigModel()
            this.orderHistoryConfig.date = this.monthSelect;
            this.myOrders = [];
            this.getList();
        },
        getList: function() {
            return new Promise((resolve) => {
                let params = this.orderHistoryConfig.getParams()
                BKMyOrder.apiGetOrderHistory(params).subscribe({
                    next: (myOrders) => {
                        this.orderHistoryConfig.intSkip += this.orderHistoryConfig.defaultTopAmount;
                        //check is there are more campaign.
                        if (myOrders && myOrders.length < this.orderHistoryConfig.defaultTopAmount) {
                            this.orderHistoryConfig.isSeeMoreEnable = false;
                        }

                        //reinitialize list if no skip.
                        if (this.orderHistoryConfig.intSkip == this.orderHistoryConfig.defaultTopAmount) {
                            this.myOrders = [];
                        }

                        for (var myOrder of myOrders) {
                            //TODO: Add GA Tracking.
                            this.myOrders.push(myOrder);
                        }
                        console.log(this.myOrders);
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = this.myOrders.length > 0
                            ? true
                            : false;

                        this.$emit('onLoaded');
                        resolve();
                    },
                    error: (err) => {
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.listConfig.isSeeMoreEnable = false;
                        this.errorApi(err);

                        this.$emit('onLoaded');
                        resolve();
                    }
                });
            });
        },
        loadMore: async function() {
            console.log('load more list', this.orderHistoryConfig.isSeeMoreEnable);
            if (!this.orderHistoryConfig.isSeeMoreEnable || this.isLoading) {
                return;
            }

            this.modal.loadingModal.show();
            this.isLoading = true;
            await this.getList();
            this.modal.loadingModal.hide();
        },
        clickDetail: async function(myOrder) {
            console.log(myOrder);
            this.modal.loadingModal.show();
            if (await this.apiGetDetail(myOrder.tranId)) {
                console.log(this.myOrderDetail);
                this.modal.orderDetailModal.clearModal()
                                        .setBtnOk("Reorder")
                                        .setorderItem(myOrder)
                                        .setOrderDetail(this.myOrderDetail)
                                        .show();
                this.modal.orderDetailModal.onClickOk(() => {
                    this.reOrder(myOrder.tranId);
                });
            }
        },
        clickReOrder: function(myOrder) {
            this.reOrder(myOrder.tranId);
        },
        clickFav: async function(index) {
            this.modal.loadingModal.show();
            if (await this.apiPostFavourite(this.myOrders[index].tranId)) {
                this.myOrders[index].isFavourite = !this.myOrders[index].isFavourite;
            }
        },
        reOrder: async function(tranId) {
            this.modal.loadingModal.show();
            if (await this.apiPostReOrder(tranId)) {
                this.$router.push("/ordersummary");
            }
        },
        apiPostReOrder: async function(tranId) {
            return new Promise((resolve) => {
                
                BKMyOrder.apiPostReOrder(tranId).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiPostFavourite: async function(tranId) {
            return new Promise((resolve) => {
                
                BKMyOrder.apiPostFavourite(tranId).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiGetDetail: async function(tranId) {
            return new Promise((resolve) => {
                this.myOrderDetail = [];
                BKMyOrder.apiGetOrderHistoryDetail(tranId).subscribe({
                    next: (myOrders) => {
                        for (var myOrder of myOrders) {
                            this.myOrderDetail.push(myOrder);
                        }
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
    }
}
</script>

<style>

</style>